<template>
<div>
    <div class="list-info mr-b20">
      <ul class="lists">
        <li v-for="objInfo in objDefineCountList" :key="objInfo.objDefineId">
          <span class="tit">{{objInfo.objDefineName}} :</span>
          <span class="high">{{objInfo.defineCount}}개</span>
        </li>
      </ul>
    </div>
    <el-row class="title-bar" type="flex" justify="space-between">
      <div class="vertical-center-box">
        <span class="title-h4 mr-r10">이벤트 예측 자원</span>
        <el-button size="mini" type="primary" class="mr-r4" @click="showEditPopup">설정</el-button>
        <el-button size="mini" class="mr-r4" :disabled="!isAbleDeleteRsc" @click="deletePredictTargetRsc">삭제</el-button>
        <el-select  class="mr-r4" style="width: 100px;" v-model="objDefineId">
          <el-option v-for="(item, index) in objDefineList" :key="index" :label="item.objDefineName" :value="item.objDefineId"></el-option>
        </el-select>
          <el-popover placement="bottom" trigger="click" v-model="showEventPopover">
            <el-row class="title-bar" type="flex" justify="end">
              <w-header-search-button size="mini" @click="popoverShowSearchTool = !popoverShowSearchTool"></w-header-search-button>
            </el-row>
            <el-scrollbar class="bar-visible">
              <el-table-wrapper style="height: 400px; width: 400px;" ref="popoverTable" v-loading="loading" :columns="targetObjColumn" :data="predictRscList"  @condition-change="loadPopoverRscTable"
              row-class-name="c-pointer" :show-search-tool="popoverShowSearchTool" :show-custom-header="true" :pagination="true" @cell-click="selectTargetObjInfo"  remote :total="popoverTotal">
              </el-table-wrapper>
            </el-scrollbar>
            <el-input class="c-pointer" @click.native="clickInputButton" style="width:300px;" slot="reference" v-model="selectedEventHistLabel" placeholder="장비 선택" readonly>
              <i slot="suffix" v-if="selectedEventHistLabel !== null"
                class="el-input__icon el-icon-circle-close el-input__clear"
                @click="clickClearable"></i>
            </el-input>
          </el-popover>
      </div>
      <w-header-search-button size="mini" @click="showSearchTool = !showSearchTool"></w-header-search-button>
    </el-row>
    <el-table-wrapper :data="predictRscTableData" :columns="predictRscTableColumn" ref="predictRscTable"  @selection-change="changeHandleSelection"
      remote :total="total" :pagination="true" style="width:100%;" :show-search-tool="showSearchTool" :show-custom-header="true" @condition-change="loadRscTable">
      <template slot-scope="scope" slot="important-rsc-slot">
        <i v-if="scope.row.importantRsc" class="text-medium fas fa-check-square state-normal" />
        <i v-else class="text-medium fal fa-square" />
      </template>
    </el-table-wrapper>
  <w-edit-target-setting-popup ref="editPopup" @reload="reloadTargetInfo"/>
</div>
</template>

<script>
import msgUtil from '@/utils/message';
import { getValueAfterCheckEmpty } from '@/utils/string';
import { isEmpty, isNil } from 'lodash';
import EventPredictSettingsAPI from '@/api/settings/common/event-predict-settings';
import WPredictTargetObjTree from '@/views/settings/operation/BasicInfoSettings/EventPredictSetting/components/PredictTargetObjTree';
import WEditTargetSettingPopup from './popup/EditTargetSettingPopup';

export default {
  name: 'WTargetSetting',
  components: {
    WPredictTargetObjTree,
    WEditTargetSettingPopup,
  },
  props: {
    activeTab: {
      type: String,
    },
  },
  data() {
    return {
      objTreeData: [],
      selectedList: [],
      showSearchTool: false,
      total: 0,
      targetObjParams: {
        objId: null,
        objDefineId: null,
      },
      // 예측 자원 트리에서 그리드 형태로 변경 후 추가된 변수
      popoverShowSearchTool: false,
      popoverTotal: 0,
      selectedEventHistLabel: null,
      predictRscList: [],
      objDefineList: [],
      objDefineId: null,
      objId: null,
      loading: false,
      showEventPopover: false,
      predictRscTableData: [],
      objDefineCountList: [],
      targetObjColumn: [
        {
          prop: 'objDefineName',
          label: '관리 구분',
          remoteProp: 'obj.obj_define_name',
          sortable: true,
          searchable: true,
          width: 100,
        },
        {
          prop: 'objName',
          label: '장비명',
          remoteProp: 'obj.obj_name',
          sortable: true,
          searchable: true,
        },
        {
          prop: 'ipaddress',
          label: 'IP 주소',
          sortable: true,
        },
      ],
      predictRscTableColumn: [
        {
          type: 'selection',
        },
        {
          prop: 'objName',
          label: '장비',
          headerAlign: 'center',
          remoteProp: 'o.obj_name',
          sortable: true,
          searchable: true,
        },
        {
          prop: 'ipaddress',
          label: 'IP 주소',
          headerAlign: 'center',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'managetypeName',
          label: '관리 구분',
          headerAlign: 'center',
          remoteProp: 'm.managetype_name',
          sortable: true,
          searchable: true,
        },
        {
          prop: 'rsctypeName',
          label: '자원 구분',
          headerAlign: 'center',
          remoteProp: 'rt.rsctype_name',
          sortable: true,
          searchable: true,
        },
        {
          prop: 'rscName',
          label: '자원',
          headerAlign: 'center',
          remoteProp: 'r.rsc_name',
          sortable: true,
          searchable: true,
        },
        {
          prop: 'rscKey',
          label: '자원키',
          headerAlign: 'center',
          remoteProp: 'ork.rsc_key',
          sortable: true,
          searchable: true,
        },
        {
          prop: 'importantRsc',
          label: '주요자원',
          headerAlign: 'center',
          align: 'center',
          sortable: true,
          scopedSlot: 'important-rsc-slot',
        },
      ],
    };
  },
  computed: {
    isAbleDeleteRsc() {
      return !isEmpty(this.selectedList) && this.selectedList.length > 0;
    },
  },
  watch: {
    objDefineId: {
      handler(value) {
        if (!isNil(value)) {
          this.selectedEventHistLabel = null;
          this.targetObjParams.objId = null;
          if (value === 'all') {
            this.targetObjParams.objDefineId = null;
          } else {
            this.targetObjParams.objDefineId = value;
          }
          this.loadRscTable();
        }
      },
      immediate: true,
    },
  },
  methods: {
    loadData() {
      if (this.activeTab === 'WTargetSetting') {
        this.objDefineId = null;
        this.selectedEventHistLabel = '';
        this.loadPredictTargetData();
        this.loadPredictRscCountList();
      }
    },
    /**
     * objDefineId별로 설정된 이벤트 예측 자원 카운트를 리턴한다.
     * @author yelim
     * @return {[type]} [description]
     */
    loadPredictRscCountList() {
      EventPredictSettingsAPI.getPredictRscCount().then((response) => {
        if (response.data.success) {
          const totalPredictInfo = [];
          let totalPredictCount = 0;
          const defineIdCountList = response.data.data;
          defineIdCountList.forEach((item) => {
            totalPredictCount += item.defineCount;
          });
          totalPredictInfo.push({ objDefineName: '전체', defineCount: totalPredictCount });
          this.objDefineCountList = totalPredictInfo.concat(defineIdCountList);
        } else {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '이벤트 예측 자원 합계 목록', false));
        }
      }).catch((e) => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '이벤트 예측 자원 합계 목록', false));
        throw new Error(e);
      });
    },
    /**
     * 이벤트 예측 자원 설정 팝업을 연다.
     * @author Ju
     */
    showEditPopup() {
      this.$refs.editPopup.open();
    },
    /**
     * 이벤트 예측 자원으로 설정된 관리 대상 목록을 조회한다.
     * @author yelim
     */
    loadPredictTargetData() {
      EventPredictSettingsAPI.getPredictTargetObjDefine().then((response) => {
        if (response.data.success) {
          const objDefineList = [];
          const result = response.data.data;
          objDefineList.push({ objDefineName: '전체', objDefineId: 'all' });
          this.objDefineList = objDefineList.concat(result);
          this.objDefineId = this.objDefineList[0].objDefineId;
          // this.targetObjParams.objDefineId = this.objDefineList[0].objDefineId;
        } else {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '이벤트 예측 자원 목록', false));
        }
      }).catch((e) => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '이벤트 예측 자원 목록', false));
        throw new Error(e);
      });
    },
    /**
     * 예측 대상으로 설정된 관리 대상 목록을 조회한다.
     * @author yelim
     * @return {[type]}
     */
    loadRscTable() {
      const tableParams = this.$refs.predictRscTable.getParameter();
      const params = {
        ...this.targetObjParams,
        ...tableParams,
      };
      EventPredictSettingsAPI.getSettingEventPredictRsc(params).then((response) => {
        if (response.data.success) {
          this.predictRscTableData = response.data.data;
          this.total = response.data.total;
        } else {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '이벤트 예측 자원 목록', false));
        }
      }).catch((e) => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '이벤트 예측 자원 목록', false));
        throw new Error(e);
      });
    },
    /**
     * 이벤트 예측 자원 목록을 조회한다.
     * @author yelim
     * @return {[type]}
     */
    loadPopoverRscTable() {
      const tableParams = this.$refs.popoverTable.getParameter();
      const params = {
        objDefineId: this.targetObjParams.objDefineId,
        ...tableParams,
      };
      EventPredictSettingsAPI.getPredictTargetObjInfo(params).then((response) => {
        if (response.data.success) {
          this.predictRscList = response.data.data;
          this.popoverTotal = response.data.total;
        } else {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '이벤트 예측 자원 목록', false));
        }
      }).catch((e) => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '이벤트 예측 자원 목록', false));
        throw new Error(e);
      });
    },
    reloadTargetInfo() {
      this.loadRscTable();
      this.loadPredictTargetData();
      this.loadPredictRscCountList();
    },
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    /**
     * 대상에 설정된 예측 자원을 삭제한다.
     * @author yelim
     */
    deletePredictTargetRsc() {
      // 삭제 대상으로 선택된 리스트
      const deleteList = this.selectedList;
      this.$confirm(...msgUtil.getBasicConfirmData(msgUtil.action.DELETE)).then(() => {
        EventPredictSettingsAPI.setSettingEventPredictRsc({ deleteList }).then((response) => {
          if (response.data.success) {
            this.reloadTargetInfo();
            this.$message(msgUtil.getResultMsgData(msgUtil.action.MODIFY, '이벤트 예측 자원', true));
          } else {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.MODIFY, '이벤트 예측 자원', false));
          }
        }).catch(() => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.MODIFY, '이벤트 예측 자원', false));
        });
      });
    },
    /**
     * 이벤트 예측 자원 그리드에서 선택된 항목을 관리한다.
     * @author yelim
     * @param  {[type]} rows [description]
     * @return {[type]}      [description]
     */
    changeHandleSelection(rows) {
      this.selectedList = rows;
    },
    /**
     * 조회할 obj를 선택한다.
     * @author yelim
     * @param  {[type]} row [description]
     */
    selectTargetObjInfo(row) {
      this.showEventPopover = false;
      this.targetObjParams.objId = row.objId;
      this.selectedEventHistLabel = `[${getValueAfterCheckEmpty(row.objName)}] ${getValueAfterCheckEmpty(row.ipaddress)}`;
      this.loadRscTable();
    },
    /**
     * input 필드를 클릭시 objDefineId 기준으로 관리대상 목록데이터를 로드한다.
     * @author yelim
     * @return {[type]} [description]
     */
    clickInputButton() {
      this.loadPopoverRscTable();
    },
    /**
     * input필드의 clearable 아이콘을 선택하면 데이터를 초기화한다.
     * @author yelim
     * @return {[type]} [description]
     */
    clickClearable() {
      if (!isNil(this.selectedEventHistLabel)) {
        this.targetObjParams.objId = null;
        this.selectedEventHistLabel = null;
        this.loadRscTable();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
//list info
//url
$url : '../../../../../assets/img/';
// .pointer input {
//   cursor: pointer;
// }
.list-info{
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  min-height: 50px;
  border: 1px solid #e9e9e9;
  background-color: #f1f1f1;
  // margin-bottom: 10px;
  padding: 4px 18px;

  & > .select{
    padding: 4px 0;
  }
  .select > .tit{
    padding-right: 10px;
    font-size: 14px;
    letter-spacing: -1px;
  }

  .custom-input{
    margin-left: 4px;

    &:first-child{
      margin-left: 0;
    }
  }

  .lists{
    display: inline-block;
    align-items: center;
    padding: 5px 0;

    & > li{
      //margin-left: 14px;
      //padding-left: 10px;
      // background: url($url + 'dot.png') no-repeat 0 5px;
      font-weight: 500;
      display: inline;
      width: 40%;

      &:first-child{
        //margin-left: 0;
        //padding-left: 0;
      }
    }
    & > li > .tit{
      display: inline-block;
      padding-right: 4px;
      font-size: 13px;
      letter-spacing: -1px;
    }
    .high{
      color: #1c768d;
      margin-right: 14px;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/views/settings/operation/BasicInfoSettings/EventPredictSetting/TargetSetting/index.vue